module.exports = __webpack_public_path__ + "static/media/incident_Reporting.95e6b33c.png";